import { Timestamp } from "firebase/firestore"

export type BookingBase = {
    StudentId: string,
    TutorId: string,
    TutorPaymentTier: string,
    SubjectId: string,
    TutorName: string,
    StudentName: string,
    Day: string,
    TimeSlotIndex96: number,
    Duration48: number,
    Timezone: string,
    Notes: string,
}

export type BookingSchema = BookingBase & {
    ValidFrom: Timestamp,
    Deleted: boolean,
}

export type SessionSchema = BookingBase & {
    BookingId:string,
    SessionTimeStamp: Timestamp,
    StudentCanceled: boolean,
    TutorCanceled: boolean,
    Completed: boolean,
}

const nameofBookingBaseStudentId = "StudentId"
const nameofBookingBaseTutorId = "TutorId"
const nameofBookingBaseTutorPaymentTier = "TutorPaymentTier"
const nameofBookingBaseSubjectId = "SubjectId"
const nameofBookingBaseTutorName = "TutorName"
const nameofBookingBaseStudentName = "StudentName"
const nameofBookingBaseDay = "Day"
const nameofBookingBaseTimeSlotIndex96 = "TimeSlotIndex96"
const nameofBookingBaseDuration48 = "Duration48"
const nameofBookingBaseTimezone = "Timezone"
const nameofBookingBaseNotes = "Notes"

const nameofBookingSchemaStartDate = "ValidFrom"
const nameofBookingSchemaDeleted = "Deleted"
const nameofBookingSchemaCollection = "Booking"

const nameofSessionSchemaBookingId = "BookingId"
const nameofSessionSchemaSessionTimeStamp = "SessionTimeStamp"
const nameofSessionSchemaStudentCanceled = "StudentCanceled"
const nameofSessionSchemaTutorCanceled = "TutorCanceled"
const nameofSessionSchemaCompleted = "Completed"
const nameofSessionSchemaCollection = "Session"

export {
    nameofBookingBaseStudentId,
    nameofBookingBaseTutorId,
    nameofBookingBaseTutorPaymentTier,
    nameofBookingBaseSubjectId,
    nameofBookingBaseTutorName,
    nameofBookingBaseStudentName,
    nameofBookingBaseDay,
    nameofBookingBaseTimeSlotIndex96,
    nameofBookingBaseDuration48,
    nameofBookingBaseTimezone,
    nameofBookingBaseNotes,
    nameofBookingSchemaStartDate,
    nameofBookingSchemaDeleted,
    nameofBookingSchemaCollection,
    nameofSessionSchemaSessionTimeStamp,
    nameofSessionSchemaBookingId,
    nameofSessionSchemaStudentCanceled,
    nameofSessionSchemaTutorCanceled,
    nameofSessionSchemaCompleted,
    nameofSessionSchemaCollection,
}

export type SessionView = SessionSchema & {
    Id: string,
}

export type BookingView = BookingSchema & {
    Id: string,
}
